export function isFeatureFlagged(session: any, _featureName: string) {
  if (!session || !session.email) {
    return false
  }

  if (["crusty.noah@gmail.com"].includes(session.email)) {
    return true
  }

  return session.email.endsWith("@getvibrato.com")
}

// Feature flags for referrals and gifts - defaulting to false
export const ENABLE_REFERRALS = false
export const ENABLE_GIFTS = false
